<template>

  <b-container fluid class="h-100 wrapper">
    <b-row class="h-100 justify-content-center align-items-center">
      <b-col cols="4"  class="loginform">

        <div class="formContainer">
          <div class="titleContainer">
            <span class="title">Welcome to the <span class="maixname">maix analytics Dashboard</span></span>
          </div>

          <b-form v-if="showLoginForm" @submit="onSubmit">

            <b-form-group id="input-group-1" label="E-Mail" label-for="input-1">
              <b-form-input id="input-1" v-model="form.username" required placeholder="Enter email"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-2" label="Kennwort" label-for="input-2">
              <b-form-input id="input-2" v-model="form.password" type="password" required placeholder="Enter Kennwort"></b-form-input>
            </b-form-group>

            <b-alert v-if="didLoginFail" show>Login error</b-alert>

            <!--              <b-form-group id="input-group-4">-->
            <!--                  <b-form-checkbox v-model="form.remember">Kennwort speichern</b-form-checkbox>-->
            <!--              </b-form-group>-->

            <div class="buttonContainer">
              <b-button type="submit" variant="primary" class="loginButton">Login</b-button>
              <a class="forgotLink" @click="onPasswordForgotten">Kennwort vergessen</a>
            </div>

          </b-form>

          <div v-else-if="showSelectRealmList">
            <b-list-group>
              <b-list-group-item v-for="r in userIdentity.realms" :key="r.name" button @click="onRealmSelected(r.name)">{{r.title}}</b-list-group-item>
            </b-list-group>
          </div>


          <b-form v-else-if="showForgotPassword">
            <b-form-group id="input-group-em" label="Enter your email to receive a reset password link" label-for="input-em">
              <b-form-input id="input-em" v-model="resetform.email" required placeholder="Enter email"></b-form-input>
            </b-form-group>
            <div class="buttonContainer">
              <b-button variant="primary" class="loginButton" @click="onSendResetLink">Send email</b-button>
            </div>
          </b-form>

          <b-form v-else-if="showResetMailSent">
            An email has been sent with instruction on resetting your password.
          </b-form>

          <div v-else-if="showFetchingRealmStructure">
            <div class="fetchingDiv">Loading...</div>
            <div class="fetchingDiv"><b-spinner variant="primary" label="Spinning"></b-spinner></div>

          </div>

        </div>

      </b-col>
    </b-row>

  </b-container>


</template>

<script>
import {mapGetters, mapState} from "vuex";
import RealmService from "../../services/RealmService";
import PageNavigator from "../../services/PageNavigator";
import AuthService from "../../services/AuthService";

export default {
  name: 'Login',

  data() {
    return {
      isInForgotPasswordState: false,
      isInRestMailSentState: false,
      isInFetchingRealmStructureState: false,

      form: {
        username: '',
        password: '',
        remember: false
      },

      resetform: {
        password: '',
      },

    }
  },

  computed: {
    ...mapGetters(['isLoggedIn', 'didLoginFail', 'isInSelectRealmState', "authToken", 'realmName', 'absoluteDrillPath', 'pageByName']),
    ...mapState(['userIdentity', 'realmStructure', 'activeStudy', 'activeView']),

    showLoginForm() {
      return !this.isInSelectRealmState && !this.isInForgotPasswordState && !this.isInRestMailSentState && !this.isInFetchingRealmStructureState
    },

    showSelectRealmList() {
      return this.isInSelectRealmState &&  !this.isInForgotPasswordState
    },

    showForgotPassword() {
      return this.isInForgotPasswordState
    },

    showResetMailSent() {
      return this.isInRestMailSentState
    },

    showFetchingRealmStructure() {
      return this.isInFetchingRealmStructureState
    }

  },

  methods: {
    onPasswordForgotten() {
      this.isInForgotPasswordState = true
    },

    onSendResetLink() {
      AuthService.resetPassword(this.resetform.email).then(() => {
        this.isInForgotPasswordState = false
        this.isInRestMailSentState = true;
      })
    },

    onSubmit(evt) {
      evt.preventDefault()

      this.$store.dispatch('authenticateUserPassword', {
        username: this.form.username,
        password: this.form.password,
        remember: this.form.remember,
        universe: null
      })

    },

    onRealmSelected(realmName) {
      // console.log("Selected: " + name)

      this.$store.dispatch('authenticateUserPassword', {
        username: this.form.username,
        password: this.form.password,
        remember: this.form.remember,
        realm: realmName
      })
    }

  },



  watch: {
    isLoggedIn: function (loginState) {
      if (loginState) {
        // console.log("Ja - angemeldet")

        this.isInFetchingRealmStructureState = true

        RealmService.fetchStructure(this.authToken, this.realmName).then((response) => {
          const structure = response.data

          this.$store.commit('realmStructure', structure)
          // console.log(structure)

          this.$store.commit('selectStudy', structure.defaultStudyName)

          PageNavigator.navigateToDefaultPage(this.$router, this.activeStudy.defaultPage, this.activeStudy.extname, this.activeView.extname, this.activeView.defaultPath)
        })

      }
    },



  }
}
</script>

<style scoped>
.wrapper {
  background-color: white;
  background-image: url('../../assets/waves_nocert.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
}

.buttonContainer {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}

.titleContainer {
  text-align: center;
}

.title {
  font-size: 1.5em;
  margin-bottom: 1em;
}

.maixname {
  color: #30bcff;
}

.formContainer {
  background-color: #65686a;
  color: white;
  padding: 1em;
}


.loginButton {
  background-color: #30bcff;
  border-color: #30bcff;
}

a.forgotLink:hover {
  text-decoration: none;
}

a.forgotLink:hover {
  text-decoration: underline;
}

.fetchingDiv {
  text-align: center;
}

</style>
